// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';

import '../../App.css';
import Header from '../../components/Header.js';
import Box from '../../components/Box';

import { Questions } from '../../assets/model';
import BoxCheck from '../BoxCheck';

type Props = {
  onClick: (number, any) => void,
  onSkip: number => void,
  onNext: number => void,
  question: number
};

type State = {
  checked: Array<boolean>
};

class TrueOrFalse extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      checked: []
    };
  }

  componentDidMount() {
    let checked = this.state.checked;
    Questions[this.props.question].answers.forEach(answer => {
      checked.push(false);
    });
    this.setState({ checked });
  }

  _changeCheckbox = (number: number, answer: any) => {
    let checked = this.state.checked;
    checked[number] = !checked[number];
    this.setState({
      checked
    });

    answer.value = checked[number];

    this.props.onClick(this.props.question, answer);
  };

  _onSkip = () => {
    Questions[this.props.question].answers.forEach(modelAnswer => {
      const answer = {
        answerPath: modelAnswer.answerPath,
        nextQuestion: modelAnswer.nextQuestion
      };
      this.props.onSkip(this.props.question, answer);
    });
    this.props.onNext(Questions[this.props.question].answers[0].nextQuestion);
  };

  render(): React.Node {
    const { question } = this.props;
    console.log(this.state.checked);
    return (
      <div className="main-transition-contianer">
        <div className="house">
          <div className="booleanElements">
            {Questions[question].answers.map((answer, i) => {
              return (
                <BoxCheck
                  key={i}
                  onClick={() => {
                    this._changeCheckbox(i, answer);
                  }}
                  checked={this.state.checked[i]}
                  question={answer.text}
                />
              );
            })}
          </div>
        </div>
        <div className="bottomBar">
          <div className="skipButton" onClick={this._onSkip}>
            Überspringen
          </div>
          <div
            onClick={() => {
              this.props.onNext(Questions[question].answers[0].nextQuestion);
            }}
            className="button"
          >
            Weiter
          </div>
        </div>
      </div>
    );
  }
}

export default TrueOrFalse;



// WEBPACK FOOTER //
// ./src/components/questions/TrueOrFalse.js